(() => {
  const initialize = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const labels = {...JSON.parse(root.querySelector('[data-government-labels]').textContent), ...JSON.parse(root.querySelector('[data-government-ui-labels]').textContent)};
    const t = (key, replacements = {}) => Object.entries(replacements).reduce((text, [name, value]) => text.replaceAll(`__${name}__`, String(value)), labels[key] || key);
    const el = (tag, className, text) => {
      const node = document.createElement(tag);
      if (className) node.className = className;
      if (text !== undefined) node.textContent = text;
      return node;
    };
    const query = (selector) => root.querySelector(selector);
    const button = (text, className, action) => {
      const node = el('button', className, text);
      node.type = 'button';
      node.addEventListener('click', action);
      return node;
    };
    const officeLabel = (office) => t(office.toLowerCase());
    const grid = query('[data-candidate-grid]');
    const search = query('[data-candidate-search]');
    const stateSelect = query('[data-state-filter]');
    const partySelect = query('[data-party-filter]');
    const pagination = query('[data-candidate-pagination]');
    const shortlistFilter = query('[data-shortlist-filter]');
    const dialog = query('[data-candidate-dialog]');
    const titleId = dialog.getAttribute('aria-labelledby');
    const storageKey = 'floptropica-election-2026-shortlist';
    let candidates = [];
    let parties = {};
    let page = 1;
    const pageSize = 24;
    let filter = {office: '', state: '', party: '', search: '', saved: false};
    let saved = new Set();
    let activeCandidate = null;
    let profileOpener = null;
    try {
      const stored = JSON.parse(localStorage.getItem(storageKey) || '[]');
      if (Array.isArray(stored)) saved = new Set(stored.filter((id) => typeof id === 'string'));
    } catch { saved = new Set(); }

    const updateUrl = () => {
      const url = new URL(location.href);
      const values = {office: filter.office, 'candidate-state': filter.state, party: filter.party, q: filter.search, shortlist: filter.saved ? '1' : '', candidate: activeCandidate?.id || '', page: page > 1 ? String(page) : ''};
      Object.entries(values).forEach(([key, value]) => value ? url.searchParams.set(key, value) : url.searchParams.delete(key));
      history.replaceState({}, '', url);
    };
    const partyDot = (code) => {
      const dot = el('span', 'gov-party-dot');
      dot.setAttribute('aria-hidden', 'true');
      dot.style.setProperty('--party-color', parties[code]?.color || '#79747e');
      return dot;
    };
    const partyLabel = (candidate) => {
      const line = el('p', 'gov-candidate__party');
      line.append(partyDot(candidate.party), el('span', '', parties[candidate.party]?.name || candidate.party));
      return line;
    };
    const syncSavedButtons = () => {
      query('[data-shortlist-count]').textContent = String(saved.size);
      root.querySelectorAll('[data-save-id]').forEach((node) => {
        const isSaved = saved.has(node.dataset.saveId);
        const candidate = candidates.find((item) => item.id === node.dataset.saveId);
        node.setAttribute('aria-pressed', String(isSaved));
        node.setAttribute('aria-label', `${t(isSaved ? 'remove' : 'save')}: ${candidate?.name || ''}`);
        node.textContent = node.classList.contains('gov-candidate__save') ? (isSaved ? '★' : '☆') : t(isSaved ? 'saved' : 'save');
      });
    };
    const toggleSaved = (candidate) => {
      saved.has(candidate.id) ? saved.delete(candidate.id) : saved.add(candidate.id);
      try { localStorage.setItem(storageKey, JSON.stringify([...saved])); } catch { root.dataset.shortlistStorage = 'unavailable'; }
      if (filter.saved) render();
      syncSavedButtons();
    };
    const saveButton = (candidate, className) => {
      const node = button('', className, () => toggleSaved(candidate));
      node.dataset.saveId = candidate.id;
      return node;
    };
    const closeProfile = () => {
      activeCandidate = null;
      updateUrl();
      if (profileOpener?.isConnected) profileOpener.focus({preventScroll: true});
      else shortlistFilter.focus({preventScroll: true});
    };
    dialog.addEventListener('close', closeProfile);
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
    const showProfile = (candidate, opener = null) => {
      activeCandidate = candidate;
      profileOpener = opener;
      const body = query('[data-profile-content]');
      const hero = el('div', 'gov-profile__hero');
      const heading = el('div', 'gov-profile__heading');
      const title = el('h2', '', candidate.name);
      title.id = titleId;
      heading.append(el('p', 'gov-kicker', officeLabel(candidate.office)), title, partyLabel(candidate));
      hero.append(heading);
      const details = el('div', 'gov-profile__detail');
      const list = el('dl');
      const fields = [[t('state'), candidate.state], [t('office'), officeLabel(candidate.office)], [t('city'), candidate.city], [t('district'), candidate.district], [t('division'), candidate.division], [t(candidate.office === 'Governor' ? 'lt_governor' : 'running_mate'), candidate.runningMate]];
      fields.forEach(([label, value]) => {
        if (!value) return;
        const pair = el('div');
        pair.append(el('dt', '', label), el('dd', '', value));
        list.append(pair);
      });
      const actions = el('div', 'gov-profile__actions');
      const shareStatus = el('p', 'gov-profile__share-status');
      shareStatus.setAttribute('role', 'status');
      const share = button(t('share'), 'gov-button', async () => {
        const url = new URL(location.href);
        url.searchParams.set('candidate', candidate.id);
        url.hash = 'candidates';
        try {
          await navigator.clipboard.writeText(url.href);
          shareStatus.textContent = t('link_copied');
        } catch { shareStatus.textContent = `${t('share_failed')} ${url.href}`; }
      });
      actions.append(saveButton(candidate, 'gov-button gov-button--dark'), share);
      details.append(list, el('p', 'gov-profile__note', t('missing_bio')), actions, el('p', 'gov-profile__note', t('shortlist_note')), shareStatus);
      body.replaceChildren(hero, details);
      syncSavedButtons();
      updateUrl();
      if (!dialog.open) dialog.showModal();
    };
    const renderCard = (candidate) => {
      const card = el('article', 'gov-candidate');
      const open = button('', 'gov-candidate__open', () => showProfile(candidate, open));
      open.setAttribute('aria-label', `${t('view_profile')}: ${candidate.name}`);
      card.style.setProperty('--party-color', parties[candidate.party]?.color || '#79747e');
      open.append(el('span', 'gov-candidate__office', officeLabel(candidate.office)), el('h3', '', candidate.name), el('p', 'gov-candidate__place', [candidate.city || candidate.division, candidate.state].filter(Boolean).join(' · ')), partyLabel(candidate), el('span', 'gov-candidate__view', `${t('view_profile')} ↗`));
      card.append(open, saveButton(candidate, 'gov-candidate__save'));
      return card;
    };
    const searchable = (value) => value.normalize('NFKD').replace(/\bs\.?\s*d\.?\b/gi, 'sd').toLocaleLowerCase().replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
    const filteredCandidates = () => {
      const words = searchable(filter.search).split(/\s+/).filter(Boolean);
      return candidates.filter((candidate) => (!filter.office || candidate.office === filter.office) && (!filter.state || candidate.state === filter.state) && (!filter.party || candidate.party === filter.party) && (!filter.saved || saved.has(candidate.id)) && words.every((word) => searchable([candidate.name, candidate.runningMate, candidate.state, candidate.city, candidate.district, candidate.division, candidate.party, parties[candidate.party]?.name || ''].join(' ')).includes(word)));
    };
    const renderPagination = (container, currentPage, totalPages, onPage) => {
      container.replaceChildren();
      if (totalPages <= 1) return;
      const control = (label, number, disabled = false) => {
        const node = button(label, '', () => onPage(number));
        node.disabled = disabled;
        return node;
      };
      container.append(control(t('previous'), currentPage - 1, currentPage === 1));
      const numbers = [...new Set([1, totalPages, currentPage - 2, currentPage - 1, currentPage, currentPage + 1, currentPage + 2])].filter((number) => number > 0 && number <= totalPages).sort((a, b) => a - b);
      let previous = 0;
      numbers.forEach((number) => {
        if (number > previous + 1) container.append(el('span', '', '…'));
        const node = control(String(number), number);
        node.setAttribute('aria-label', `${t('page')} ${number}`);
        if (number === currentPage) node.setAttribute('aria-current', 'page');
        container.append(node); previous = number;
      });
      container.append(control(t('next'), currentPage + 1, currentPage === totalPages));
    };
    const partyDialog = query('[data-party-dialog]');
    const partySearch = query('[data-party-dialog-search]');
    let partyCode = '';
    let partyPage = 1;
    let partyOpener = null;
    const renderParty = () => {
      const words = searchable(partySearch.value).split(/\s+/).filter(Boolean);
      const matches = candidates.filter((candidate) => candidate.party === partyCode && words.every((word) => searchable([candidate.name, candidate.state, candidate.city, candidate.office, candidate.runningMate].join(' ')).includes(word)));
      const pages = Math.max(1, Math.ceil(matches.length / pageSize)); partyPage = Math.min(partyPage, pages);
      query('[data-party-dialog-grid]').replaceChildren(...matches.slice((partyPage - 1) * pageSize, partyPage * pageSize).map(renderCard));
      query('[data-party-dialog-count]').textContent = matches.length ? t('showing_range', {from: (partyPage - 1) * pageSize + 1, to: Math.min(matches.length, partyPage * pageSize), total: matches.length}) : t('no_matches');
      renderPagination(query('[data-party-dialog-pages]'), partyPage, pages, (number) => { partyPage = number; renderParty(); partyDialog.scrollTop = 0; partySearch.focus({preventScroll: true}); });
      syncSavedButtons();
    };
    const showParty = (code, opener) => {
      partyCode = code; partyPage = 1; partySearch.value = ''; partyOpener = opener;
      query('[data-party-dialog-title]').textContent = parties[code].name;
      partyDialog.style.setProperty('--party-color', parties[code].color || '#79747e');
      renderParty(); partyDialog.showModal(); partyDialog.scrollTop = 0;
    };
    partySearch.addEventListener('input', () => { partyPage = 1; renderParty(); });
    query('[data-party-dialog-close]').addEventListener('click', () => partyDialog.close());
    partyDialog.addEventListener('close', () => partyOpener?.focus({preventScroll: true}));
    const render = () => {
      const matches = filteredCandidates();
      const pages = Math.max(1, Math.ceil(matches.length / pageSize));
      page = Math.max(1, Math.min(page, pages));
      const shown = matches.slice((page - 1) * pageSize, page * pageSize);
      const focusedSave = document.activeElement?.dataset.saveId;
      if (shown.length) grid.replaceChildren(...shown.map(renderCard));
      else {
        const empty = el('div', 'gov-empty');
        empty.append(el('p', '', t(filter.saved && !saved.size ? 'empty_shortlist' : 'no_matches')), button(t('all_offices'), 'gov-button', reset));
        grid.replaceChildren(empty);
      }
      grid.setAttribute('aria-busy', 'false');
      renderPagination(pagination, page, pages, (nextPage) => {
        page = nextPage; render(); updateUrl();
        grid.scrollIntoView({block: 'start', behavior: 'instant'});
        grid.querySelector('button')?.focus({preventScroll: true});
      });
      query('[data-candidate-count]').textContent = matches.length ? t('showing_range', {from: (page - 1) * pageSize + 1, to: (page - 1) * pageSize + shown.length, total: matches.length}) : t('showing', {shown: 0, total: 0});
      shortlistFilter.setAttribute('aria-pressed', String(filter.saved));
      root.querySelectorAll('[data-office]').forEach((node) => node.setAttribute('aria-pressed', String(node.dataset.office === filter.office)));
      stateSelect.value = filter.state;
      partySelect.value = filter.party;
      search.value = filter.search;
      syncSavedButtons();
      if (focusedSave && !dialog.open) {
        const target = [...grid.querySelectorAll('[data-save-id]')].find((node) => node.dataset.saveId === focusedSave);
        (target || shortlistFilter).focus({preventScroll: true});
      }
    };
    function reset() {
      filter = {office: '', state: '', party: '', search: '', saved: false};
      page = 1;
      render();
      updateUrl();
    }
    const changeFilter = (changes) => {
      filter = {...filter, ...changes};
      page = 1;
      render();
      updateUrl();
    };
    root.querySelectorAll('[data-office]').forEach((node) => node.addEventListener('click', () => changeFilter({office: node.dataset.office})));
    search.addEventListener('input', () => changeFilter({search: search.value}));
    stateSelect.addEventListener('change', () => changeFilter({state: stateSelect.value}));
    partySelect.addEventListener('change', () => changeFilter({party: partySelect.value}));
    shortlistFilter.addEventListener('click', () => changeFilter({saved: !filter.saved}));
    query('[data-filter-reset]').addEventListener('click', reset);
    const readFilterUrl = () => {
      const params = new URL(location.href).searchParams;
      page = Math.max(1, Number.parseInt(params.get('page'), 10) || 1);
      filter = {office: ['Senate', 'Governor', 'Mayor'].includes(params.get('office')) ? params.get('office') : '', state: candidates.some((item) => item.state === params.get('candidate-state')) ? params.get('candidate-state') : '', party: Object.hasOwn(parties, params.get('party')) ? params.get('party') : '', search: params.get('q') || '', saved: params.get('shortlist') === '1'};
      render();
      const candidate = candidates.find((item) => item.id === params.get('candidate'));
      if (candidate) showProfile(candidate);
      else if (dialog.open) dialog.close();
    };
    const partyContrast = (hex) => {
      const value = hex.replace('#', '');
      const rgb = [0, 2, 4].map((offset) => parseInt(value.slice(offset, offset + 2), 16) / 255).map((color) => color <= .04045 ? color / 12.92 : ((color + .055) / 1.055) ** 2.4);
      return rgb[0] * .2126 + rgb[1] * .7152 + rgb[2] * .0722 > .179 ? '#221b32' : '#ffffff';
    };
    const loadCandidates = async () => {
      grid.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(root.dataset.candidatesUrl);
        if (!response.ok) throw new Error('Candidate data unavailable');
        const data = await response.json();
        if (!Array.isArray(data.candidates) || !data.parties) throw new Error('Invalid candidate data');
        candidates = data.candidates.slice().sort((a, b) => a.name.localeCompare(b.name));
        parties = data.parties;
        saved = new Set([...saved].filter((id) => candidates.some((candidate) => candidate.id === id)));
        const states = [...new Set(candidates.map((candidate) => candidate.state))].sort();
        stateSelect.replaceChildren(new Option(t('all_states'), ''), ...states.map((state) => new Option(state, state)));
        const codes = Object.keys(parties).sort((a, b) => parties[a].name.localeCompare(parties[b].name));
        partySelect.replaceChildren(new Option(t('all_parties'), ''), ...codes.map((code) => new Option(parties[code].name, code)));
        const summary = query('[data-candidate-summary]');
        summary.replaceChildren(...[[candidates.length, t('nominations')], [states.length, t('states')], [codes.length, t('parties')]].map(([count, label]) => {
          const item = el('div');
          item.append(el('strong', '', count), el('span', '', label));
          return item;
        }));
        summary.hidden = false;
        query('[data-candidate-controls]').hidden = false;
        query('[data-party-list]').replaceChildren(...codes.map((code) => {
          const party = parties[code];
          const count = candidates.filter((candidate) => candidate.party === code).length;
          const node = button('', 'gov-party', () => showParty(code, node));
          const badge = el('span', 'gov-party__code', code);
          badge.style.setProperty('--party-color', party.color || '#79747e');
          badge.style.color = partyContrast(party.color || '#79747e');
          const name = el('span', 'gov-party__name', party.name);
          name.append(el('span', 'gov-party__count', t('candidate_count', {count}) + (!party.color ? ` · ${t('color_pending')}` : '')));
          const arrow = el('span', 'gov-party__arrow', '↗');
          arrow.setAttribute('aria-hidden', 'true');
          node.append(badge, name, arrow);
          return node;
        }));
        readFilterUrl();
        renderAtlasCandidates();
        renderResults();
      } catch {
        grid.setAttribute('aria-busy', 'false');
        const empty = el('div', 'gov-empty');
        empty.append(el('p', '', t('load_error')), button(t('retry'), 'gov-button', loadCandidates));
        grid.replaceChildren(empty);
        query('[data-party-list]').replaceChildren(el('p', '', t('load_error')));
      }
    };
    window.addEventListener('popstate', () => { if (candidates.length && root.isConnected) readFilterUrl(); });
    window.addEventListener('storage', (event) => {
      if (event.key !== storageKey || !root.isConnected) return;
      try {
        const value = JSON.parse(event.newValue || '[]');
        if (Array.isArray(value)) saved = new Set(value.filter((id) => candidates.some((item) => item.id === id)));
      } catch { return; }
      render();
    });

    const choices = query('[data-map-choices]');
    const back = query('[data-map-back]');
    const mapCandidates = query('[data-map-candidates]');
    let geography;
    let current = {state: null, district: null, city: null, special: null};
    const mapUrl = () => {
      const url = new URL(location.href);
      Object.entries(current).forEach(([key, value]) => value ? url.searchParams.set(key, value) : url.searchParams.delete(key));
      history.replaceState({}, '', url);
    };
    const renderMap = () => {
      const state = geography.states.find((item) => item.id === current.state);
      const district = geography.districts.find((item) => item.id === current.district && item.state_id === state?.id);
      const city = geography.cities.find((item) => item.id === current.city && item.district_id === district?.id) || (geography.unplacedCities || []).find((item) => item.id === current.city && item.state_id === state?.id);
      const special = geography.specialDistricts.find((item) => item.id === current.special);
      const names = [t('national')];
      let records = geography.states;
      let level = 'national_view';
      let description = t('atlas_intro');
      let selection = t('floptropica');
      const choose = (key, id) => {
        const specialCity = key === 'city' ? geography.cities.find((item) => item.id === id && item.special_id) : null;
        if (specialCity) { current = {state: null, district: null, city: null, special: specialCity.special_id}; mapUrl(); renderMap(); return; }
        current = key === 'state' ? {state: id, district: null, city: null, special: null} : key === 'district' ? {...current, district: id, city: null} : {...current, city: id};
        mapUrl();
        renderMap();
      };
      let action = (record) => choose('state', record.id);
      if (state) {
        names.push(state.name);
        selection = state.name;
        level = 'state_view';
        description = t('pick_district');
        records = geography.districts.filter((item) => item.state_id === state.id);
        action = (record) => choose('district', record.id);
        if (district) {
          names.push(district.name);
          selection = district.name;
          level = 'district_view';
          description = t('pick_city');
          records = geography.cities.filter((item) => item.district_id === district.id);
          action = (record) => choose('city', record.id);
          if (city) {
            names.push(city.name);
            selection = city.name;
            level = 'city_view';
            description = t('city_description', {city: city.name, district: district.name, state: state.name});
            records = [];
          }
        }
      }
      if (city && !district && !special) {
        names.push(city.name); selection = city.name; level = 'city_view'; description = t('unplaced_city_note'); records = [];
      }
      if (special) {
        selection = special.name;
        level = 'special_district';
        names.push(special.name);
        records = [];
        description = t('special_description', {state: geography.states.find((item) => item.id === special.parent_state_id)?.name || ''});
      }
      contest.querySelector('option[value=governor]').disabled = Boolean(special);
      if (special && contest.value === 'governor') contest.value = 'senate';
      query('[data-map-selection]').textContent = selection;
      query('[data-map-level]').textContent = t(level);
      query('[data-map-description]').textContent = description;
      query('[data-map-crumbs]').replaceChildren(...names.map((name) => el('li', '', name)));
      choices.replaceChildren(...records.map((record) => button(`${record.source_label || record.name} ↗`, '', () => action(record))));
      if (!state && !special) geography.specialDistricts.forEach((record) => choices.append(button(`${record.name} · ${t('special_district')}`, '', () => {
        current = {state: null, district: null, city: null, special: record.id};
        mapUrl();
        renderMap();
      })));
      if (state && !district && !city) (geography.unplacedCities || []).filter((item) => item.state_id === state.id).forEach((record) => choices.append(button(`${record.name} · ${t('unplaced_city')}`, '', () => { current = {...current, district: null, city: record.id}; mapUrl(); renderMap(); })));
      back.hidden = !state && !special;
      mapCandidates.hidden = !state && !special;
      renderAtlasCandidates();
      syncMap();
    };
    back.addEventListener('click', () => {
      if (current.special) current.special = null;
      else if (current.city) current.city = null;
      else if (current.district) current.district = null;
      else current.state = null;
      mapUrl();
      renderMap();
    });
    mapCandidates.addEventListener('click', () => {
      const special = geography.specialDistricts.find((item) => item.id === current.special);
      const state = geography.states.find((item) => item.id === (special?.parent_state_id || current.state));
      const city = [...geography.cities, ...(geography.unplacedCities || [])].find((item) => item.id === current.city);
      const district = geography.districts.find((item) => item.id === current.district);
      changeFilter({state: state?.name || '', office: '', party: '', search: special?.name || city?.name || district?.name || '', saved: false});
    });
    const loadGeography = async () => {
      try {
        const response = await fetch(`${root.dataset.apiUrl}/api/v1/geography`, {headers: {Accept: 'application/json'}});
        if (!response.ok) throw new Error('Geography unavailable');
        geography = await response.json();
        const params = new URL(location.href).searchParams;
        const state = geography.states.find((item) => item.id === params.get('state'));
        const district = geography.districts.find((item) => item.id === params.get('district') && item.state_id === state?.id);
        const city = geography.cities.find((item) => item.id === params.get('city') && item.district_id === district?.id) || (geography.unplacedCities || []).find((item) => item.id === params.get('city') && item.state_id === state?.id);
        const special = geography.specialDistricts.find((item) => item.id === params.get('special'));
        current = special ? {state: null, district: null, city: null, special: special.id} : {state: state?.id, district: district?.id, city: city?.id, special: null};
        renderMap();
      } catch {
        choices.replaceChildren(el('p', '', t('geography_error')), button(t('retry'), 'gov-text-button', loadGeography));
      }
    };
    let geometry;
    let resultsSnapshot = null;
    let resultsFailed = false;
    let resultsLoading = false;
    let areaPage = 1;
    let areaKey = '';
    const svg = query('[data-map-svg]');
    const viewport = query('[data-map-viewport]');
    const regions = query('[data-map-regions]');
    const markers = query('[data-map-markers]');
    const contest = query('[data-results-contest]');
    const svgNode = (tag, attrs = {}) => {
      const node = document.createElementNS('http://www.w3.org/2000/svg', tag);
      Object.entries(attrs).forEach(([key, value]) => node.setAttribute(key, String(value)));
      return node;
    };
    const readContest = new URL(location.href).searchParams.get('contest');
    if (['governor', 'senate', 'party-list'].includes(readContest)) contest.value = readContest;
    let view = [0, 0, 1811, 1376];
    let animation = 0;
    const applyView = (next) => {
      const width = Math.max(110, Math.min(1811, next[2]));
      const height = width * 1376 / 1811;
      view = [Math.max(-80, Math.min(1811 - width + 80, next[0])), Math.max(-60, Math.min(1376 - height + 60, next[1])), width, height];
      svg.setAttribute('viewBox', view.join(' '));
      markers.querySelectorAll('circle').forEach((node) => node.setAttribute('r', String(view[2] * .008)));
    };
    const moveView = (next, animate = true) => {
      cancelAnimationFrame(animation);
      if (!animate || matchMedia('(prefers-reduced-motion: reduce)').matches) return applyView(next);
      const from = view.slice();
      const start = performance.now();
      const step = (now) => {
        if (!root.isConnected) return;
        const progress = Math.min(1, (now - start) / 420);
        const ease = 1 - (1 - progress) ** 3;
        applyView(next.map((value, index) => from[index] + (value - from[index]) * ease));
        if (progress < 1) animation = requestAnimationFrame(step);
      };
      animation = requestAnimationFrame(step);
    };
    const focusBounds = (bounds) => {
      if (!bounds) return moveView([0, 0, 1811, 1376]);
      const [x, y, w, h] = bounds;
      const width = Math.min(1811, Math.max(180, w * 1.35, h * 1811 / 1376 * 1.35));
      moveView([x + w / 2 - width / 2, y + h / 2 - width * 1376 / 1811 / 2, width, width * 1376 / 1811]);
    };
    const zoom = (factor) => {
      const width = view[2] * factor;
      moveView([view[0] + (view[2] - width) / 2, view[1] + (view[3] - width * 1376 / 1811) / 2, width, width * 1376 / 1811]);
    };
    root.querySelectorAll('[data-map-zoom]').forEach((node) => node.addEventListener('click', () => zoom(node.dataset.mapZoom === 'in' ? .65 : 1.55)));
    query('[data-map-reset]').addEventListener('click', () => moveView([0, 0, 1811, 1376]));
    viewport.addEventListener('keydown', (event) => {
      const directions = {ArrowLeft: [-1, 0], ArrowRight: [1, 0], ArrowUp: [0, -1], ArrowDown: [0, 1]};
      if (directions[event.key]) {
        event.preventDefault();
        const [x, y] = directions[event.key];
        moveView([view[0] + x * view[2] * .15, view[1] + y * view[3] * .15, view[2], view[3]], false);
      } else if (['+', '=', '-', 'Home'].includes(event.key)) {
        event.preventDefault();
        if (event.key === 'Home') moveView([0, 0, 1811, 1376]);
        else zoom(event.key === '-' ? 1.4 : .7);
      }
    });
    const pointers = new Map();
    let gesture = null;
    let dragged = false;
    const gestureStart = () => {
      const points = [...pointers.values()];
      gesture = {view: view.slice(), point: points[0], distance: points.length > 1 ? Math.hypot(points[0][0] - points[1][0], points[0][1] - points[1][1]) : 0};
    };
    viewport.addEventListener('pointerdown', (event) => {
      if (event.button !== 0) return;
      cancelAnimationFrame(animation);
      pointers.set(event.pointerId, [event.clientX, event.clientY]);
      viewport.setPointerCapture(event.pointerId);
      dragged = false;
      gestureStart();
    });
    viewport.addEventListener('pointermove', (event) => {
      if (!pointers.has(event.pointerId)) return;
      pointers.set(event.pointerId, [event.clientX, event.clientY]);
      const points = [...pointers.values()];
      const rect = viewport.getBoundingClientRect();
      const scale = Math.min(rect.width / gesture.view[2], rect.height / gesture.view[3]);
      const dx = points[0][0] - gesture.point[0];
      const dy = points[0][1] - gesture.point[1];
      if (Math.abs(dx) + Math.abs(dy) > 5 || points.length > 1) dragged = true;
      if (points.length > 1 && gesture.distance > 0) {
        const distance = Math.hypot(points[0][0] - points[1][0], points[0][1] - points[1][1]);
        const width = gesture.view[2] * gesture.distance / Math.max(1, distance);
        applyView([gesture.view[0] + (gesture.view[2] - width) / 2, gesture.view[1] + (gesture.view[3] - width * 1376 / 1811) / 2, width, width * 1376 / 1811]);
      } else applyView([gesture.view[0] - dx / scale, gesture.view[1] - dy / scale, gesture.view[2], gesture.view[3]]);
    });
    const pointerEnd = (event) => {
      const wasDrag = dragged;
      pointers.delete(event.pointerId);
      if (pointers.size) gestureStart();
      else if (!wasDrag && event.type === 'pointerup') {
        const target = document.elementFromPoint(event.clientX, event.clientY)?.closest('[data-state-id]');
        if (target && svg.contains(target)) chooseMapState(target.dataset.stateId, target.dataset.districtId);
      }
    };
    viewport.addEventListener('pointerup', pointerEnd);
    viewport.addEventListener('pointercancel', pointerEnd);
    viewport.addEventListener('wheel', (event) => {
      if (!event.ctrlKey && !event.metaKey) return;
      event.preventDefault();
      zoom(event.deltaY < 0 ? .8 : 1.25);
    }, {passive: false});
    const chooseMapState = (id, districtId = null) => {
      current = {state: id, district: current.state === id ? districtId : null, city: null, special: null};
      mapUrl();
      renderMap();
    };
    const renderAtlasCandidates = () => {
      const list = query('[data-map-candidate-list]');
      if (!geography) return;
      const special = geography.specialDistricts.find((item) => item.id === current.special);
      const state = geography.states.find((item) => item.id === (special?.parent_state_id || current.state));
      const district = geography.districts.find((item) => item.id === current.district);
      const city = [...geography.cities, ...(geography.unplacedCities || [])].find((item) => item.id === current.city);
      list.replaceChildren(el('h4', '', t('atlas_candidates')));
      if (!state) { list.append(el('p', '', t('select_area'))); return; }
      if (!candidates.length) { list.append(el('p', '', t('loading_geography'))); return; }
      const key = [current.state, current.district, current.city, current.special].join(':');
      if (key !== areaKey) { areaKey = key; areaPage = 1; }
      const same = (a, b) => searchable(a || '') === searchable(b || '');
      const stateCandidates = candidates.filter((candidate) => same(candidate.state, state.name));
      let matches = stateCandidates;
      if (special) matches = stateCandidates.filter((candidate) => searchable(`${candidate.city} ${candidate.division}`).includes(searchable(special.name)));
      else if (city) matches = stateCandidates.filter((candidate) => searchable(candidate.city || '').replace(/ sd$/, '') === searchable(city.name).replace(/ sd$/, ''));
      else if (district) matches = stateCandidates.filter((candidate) => same(candidate.district, district.source_label) || same(candidate.district, district.name));
      const row = (candidate) => {
        const node = button('', 'gov-atlas-candidate', () => showProfile(candidate, node));
        const text = el('span');
        text.append(el('strong', '', candidate.name), el('small', '', `${officeLabel(candidate.office)} · ${candidate.city || candidate.state} · ${candidate.party}`));
        node.append(partyDot(candidate.party), text, el('span', '', '↗'));
        node.setAttribute('aria-label', `${t('view_profile')}: ${candidate.name}`);
        return node;
      };
      list.append(el('p', '', `${matches.length} ${t(matches.length === 1 ? 'nomination' : 'nominations')}`));
      if (!matches.length) list.append(el('p', '', t('no_area_candidates')));
      list.append(...matches.slice((areaPage - 1) * 12, areaPage * 12).map(row));
      if (matches.length > 12) { const pages = el('nav', 'gov-pagination'); pages.setAttribute('aria-label', t('pagination')); renderPagination(pages, areaPage, Math.ceil(matches.length / 12), (number) => { areaPage = number; renderAtlasCandidates(); }); list.append(pages); }
      if ((city || district || special) && stateCandidates.some((candidate) => candidate.office !== 'Mayor')) {
        const statewide = el('details', 'gov-atlas-statewide');
        statewide.append(el('summary', '', t('statewide_races')));
        statewide.append(...stateCandidates.filter((candidate) => candidate.office !== 'Mayor').map(row));
        list.append(statewide);
      }
    };
    const leader = (row) => {
      const tallies = [...(row?.tallies || [])].sort((a, b) => b.votes - a.votes);
      if (!tallies.length || tallies[0].votes === 0) return null;
      return {party: tallies[0].party, tied: tallies[0].votes === tallies[1]?.votes, votes: tallies[0].votes};
    };
    const resultsReleased = () => Date.now() >= Date.parse('2026-11-03T10:30:00Z');
    const renderResults = () => {
      const resultParties = {...parties, LCR: {name: 'Liberal Cvmocrats-Reform (LCR)', color: '#FDDA0D'}};
      const rows = (resultsReleased() ? resultsSnapshot?.states || [] : []).filter((row) => row.contest === contest.value);
      const reported = rows.filter((row) => leader(row));
      const counts = new Map();
      regions.querySelectorAll('.gov-map-region[data-state-id]').forEach((node) => {
        const record = rows.find((row) => row.stateId === node.dataset.stateId);
        const lead = leader(record);
        node.style.fill = lead && !lead.tied ? resultParties[lead.party]?.color || '#79747e' : '#79747e';
        node.dataset.reported = String(Boolean(lead));
        node.dataset.selected = String(node.dataset.stateId === current.state);
        const name = geography?.states.find((state) => state.id === node.dataset.stateId)?.name || node.dataset.stateId;
        node.querySelector('title').textContent = `${name} · ${lead ? lead.tied ? t('tied') : `${t('leading')}: ${lead.party}` : t(resultsReleased() ? 'no_reports' : 'results_available')}`;
      });
      reported.forEach((row) => {
        const lead = leader(row);
        const key = lead.tied ? 'tie' : lead.party;
        counts.set(key, (counts.get(key) || 0) + 1);
      });
      const released = resultsReleased();
      const progress = query('[data-returns-progress]');
      const returns = resultsSnapshot?.returns;
      progress.hidden = !released || returns?.mode !== 'scheduled_release';
      progress.replaceChildren();
      if (!progress.hidden) {
        const percent = Number.isFinite(returns.percentReleased) ? Math.min(100, Math.max(0, returns.percentReleased)) : 0;
        const meter = el('progress'); meter.max = 100; meter.value = percent; meter.setAttribute('aria-label', t('returns_label'));
        progress.append(el('strong', '', t('returns_label')), meter,
          el('p', '', t('returns_progress', {percent: percent.toLocaleString(undefined, {maximumFractionDigits: 2}), published: returns.publishedBallots.toLocaleString(), total: returns.totalBallots.toLocaleString()})),
          el('p', 'gov-returns__note', t('returns_explanation')));
      }

      contest.closest('label').hidden = !released;
      if (!released) {
        const status = t('results_available');
        query('[data-results-status]').textContent = status;
        query('[data-map-results-status]').textContent = status;
        query('[data-hero-result]').replaceChildren(document.createTextNode('03'), el('span', '', 'NOV'));
        query('[data-hero-result-note]').textContent = status;
        query('[data-map-legend]').replaceChildren();
        query('[data-map-contest-results]').replaceChildren();
        query('[data-results-summary]').replaceChildren();
        return;
      }
      const unavailable = resultsFailed && !resultsSnapshot;
      const verifying = Date.now() >= Date.parse('2026-11-03T13:30:00Z') && Date.now() < Date.parse('2026-11-03T13:50:00Z');
      const status = unavailable ? t('reporting_unavailable') : resultsFailed ? t('results_stale') : resultsSnapshot?.certified ? t('results_certified') : verifying ? t('certification_hold') : resultsSnapshot?.reporting === 'complete' ? t('returns_complete') : reported.length ? t('reporting_live') : t(resultsReleased() ? 'no_reports' : 'results_available');
      const updated = (resultsSnapshot?.generatedAt || resultsSnapshot?.updatedAt) ? ` · ${t('feed_updated')} ${new Intl.DateTimeFormat('en-US', {month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZone: 'Asia/Singapore'}).format(new Date(resultsSnapshot.generatedAt || resultsSnapshot.updatedAt))} (UTC+8)` : '';
      query('[data-results-status]').textContent = status;
      query('[data-map-results-status]').textContent = `${status}${updated}`;
      const hero = query('[data-hero-result]');
      hero.replaceChildren(document.createTextNode(reported.length ? `${reported.length}/12` : '03'), el('span', '', reported.length ? t('reported_states') : 'NOV'));
      query('[data-hero-result-note]').textContent = status;
      const legend = query('[data-map-legend]');
      const neutral = el('span'); const dot = el('i'); dot.style.background = '#79747e'; neutral.append(dot, document.createTextNode(t(resultsReleased() ? 'no_reports' : 'results_available')));
      legend.replaceChildren(neutral);
      Object.entries(resultParties).forEach(([code, party]) => { const item = el('span'); const dot = el('i'); dot.style.background = party.color || '#79747e'; item.append(dot, document.createTextNode(code)); legend.append(item); });
      const stateId = current.state || geography?.specialDistricts.find((item) => item.id === current.special)?.parent_state_id;
      const selectedState = geography?.states.find((item) => item.id === stateId);
      const stateResult = current.special ? (resultsSnapshot?.specialDistricts || []).find((row) => row.specialId === current.special && row.contest === contest.value) : rows.find((row) => row.stateId === stateId);
      const statePanel = query('[data-map-contest-results]');
      statePanel.replaceChildren();
      if (selectedState) {
        statePanel.append(el('h4', '', `${current.special ? geography.specialDistricts.find((item) => item.id === current.special)?.name : selectedState.name} · ${contest.options[contest.selectedIndex].text}`));
        const total = (stateResult?.tallies || []).reduce((sum, tally) => sum + tally.votes, 0);
        if (!total) statePanel.append(el('p', '', t(resultsReleased() ? 'no_reports' : 'results_available')));
        else [...stateResult.tallies].sort((a, b) => b.votes - a.votes).forEach((tally) => {
          const row = el('div', 'gov-result-row'); const dot = el('i'); dot.style.background = resultParties[tally.party]?.color || '#79747e';
          row.append(dot, el('span', '', tally.party), el('strong', '', `${tally.votes.toLocaleString()} ${t('votes')} · ${(100 * tally.votes / total).toFixed(1)}%`));
          statePanel.append(row);
        });
        if (total) statePanel.append(el('p', '', leader(stateResult)?.tied ? t('tied') : t('not_winner')));
        const races = (resultsSnapshot?.races || []).filter((race) => current.special ? race.jurisdictionType === 'special_district' && race.jurisdictionId === current.special && race.office === contest.value : current.city ? race.office === 'mayor' && race.jurisdictionId === current.city : race.jurisdictionType === 'state' && race.jurisdictionId === stateId && race.office === contest.value);
        if (races.length && contest.value !== 'party-list') {
          const detail = el('details', 'gov-race-results'); detail.append(el('summary', '', t(current.city ? 'mayor_vote' : 'candidate_totals')));
          races.forEach((race) => { const line = el('div', 'gov-result-row'); line.append(el('span', '', race.candidate?.name || (race.selectionId === 'abstain' ? t('abstain') : race.selectionId)), el('strong', '', `${race.votes.toLocaleString()} ${t('votes')}`)); detail.append(line); }); statePanel.append(detail);
        }

      }
      const summary = query('[data-results-summary]');
      summary.replaceChildren(el('p', '', `${contest.options[contest.selectedIndex].text} · ${reported.length}/12 ${t('reported_states')}`));
      if (!reported.length) summary.append(el('p', '', unavailable ? t('reporting_unavailable') : t('no_reports')));
      [...counts].sort((a, b) => b[1] - a[1]).forEach(([code, count]) => {
        const row = el('div', 'gov-result-row'); const dot = el('i'); dot.style.background = resultParties[code]?.color || '#79747e';
        row.append(dot, el('span', '', code === 'tie' ? t('tied') : resultParties[code]?.name || code), el('strong', '', `${count} ${t('leading_states')}`)); summary.append(row);
      });
      summary.append(el('p', '', `${t('not_winner')}${updated}`));
    };
    const syncMap = () => {
      if (!geometry || !geography) return;
      const stateId = current.state || geography.specialDistricts.find((item) => item.id === current.special)?.parent_state_id;
      const district = geometry.districts[current.district];
      const city = [...geography.cities, ...(geography.unplacedCities || [])].find((item) => item.id === current.city);
      const point = geometry.cities?.[city?.id];
      const specialPoint = geometry.specialDistricts?.[current.special];
      focusBounds(point ? [point[0] - 40, point[1] - 30, 80, 60] : specialPoint ? [specialPoint[0] - 40, specialPoint[1] - 30, 80, 60] : district?.bounds || geometry.states[stateId]?.bounds);
      regions.querySelectorAll('[data-district-id]').forEach((node) => node.remove());
      if (current.state) geography.districts.filter((item) => item.state_id === current.state).forEach((districtRecord) => {
        const shape = geometry.districts[districtRecord.id];
        if (!shape?.path) return;
        const path = svgNode('path', {d: shape.path, class: 'gov-map-district', 'data-state-id': current.state, 'data-district-id': districtRecord.id, 'data-selected': String(districtRecord.id === current.district)});
        const title = svgNode('title'); title.textContent = districtRecord.name; path.append(title); regions.append(path);
      });
      markers.replaceChildren();
      if (point || specialPoint) {
        const [x, y] = point || specialPoint;
        markers.append(svgNode('circle', {cx: x, cy: y, r: view[2] * .008, fill: '#5a35c8', stroke: '#fff', 'stroke-width': 2, 'vector-effect': 'non-scaling-stroke'}));
      } else if (city && district) query('[data-map-description]').append(document.createTextNode(` ${t('city_extent')}`));
      renderResults();
    };
    const loadGeometry = async () => {
      try {
        const response = await fetch(root.dataset.mapUrl);
        if (!response.ok) throw new Error('Map geometry unavailable');
        geometry = await response.json();
        const defs = svgNode('defs'); const clip = svgNode('clipPath', {id: `gov-coast-${root.closest('.shopify-section')?.id || 'home'}`});
        clip.append(svgNode('path', {d: geometry.coast})); defs.append(clip); svg.prepend(defs);
        if (geometry.version !== 2) regions.setAttribute('clip-path', `url(#${clip.id})`);
        Object.entries(geometry.states).forEach(([id, state]) => {
          const path = svgNode('path', {d: state.path, class: 'gov-map-region', 'data-state-id': id, fill: '#79747e'});
          const title = svgNode('title'); title.textContent = id; path.append(title); regions.append(path);
        });
        syncMap();
      } catch {
        query('[data-map-results-status]').textContent = t('geography_error');
        query('[data-map-results-status]').append(button(t('retry'), 'gov-text-button', loadGeometry));
      }
    };
    const loadResults = async () => {
      if (resultsLoading || !root.isConnected) return;
      if (!resultsReleased()) { resultsSnapshot = null; resultsFailed = false; renderResults(); return; }
      resultsLoading = true;
      try {
        const response = await fetch(`${root.dataset.apiUrl}/api/v1/results`, {headers: {Accept: 'application/json'}, signal: AbortSignal.timeout(15000)});
        if (!response.ok) throw new Error('Results unavailable');
        const snapshot = await response.json();
        if (!Array.isArray(snapshot.states) || !['not_started', 'reporting', 'complete'].includes(snapshot.reporting)) throw new Error('Invalid results');
        resultsSnapshot = snapshot;
        resultsFailed = false;
      } catch { resultsFailed = true; }
      finally { resultsLoading = false; renderResults(); }
    };
    contest.addEventListener('change', () => {
      const url = new URL(location.href); url.searchParams.set('contest', contest.value); history.replaceState({}, '', url);
      renderResults();
    });
    const resultsTimer = setInterval(() => {
      if (!root.isConnected) { clearInterval(resultsTimer); return; }
      if (!document.hidden) void loadResults();
    }, 60000);
    document.addEventListener('visibilitychange', () => { if (!document.hidden && root.isConnected) void loadResults(); });
    void loadGeometry();
    void loadResults();
    void loadCandidates();
    void loadGeography();
  };
  const boot = () => document.querySelectorAll('[data-government-home]').forEach(initialize);
  boot();
  document.addEventListener('shopify:section:load', boot);
})();
